import { render, staticRenderFns } from "./ProgramHealth.vue?vue&type=template&id=0918d232&"
import script from "./ProgramHealth.vue?vue&type=script&lang=js&"
export * from "./ProgramHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports